import React from 'react';
import { useFormContext } from 'react-hook-form';
const SpecialNeeds = () => {
  const {
    register,
    watch
  } = useFormContext();
  const hasCorporation = watch('corporateInfo.exists');
  return <div className="space-y-8" data-id="element-867" data-mp="3lq3b1xr658cc">
      <div className="bg-slate-50 p-4 rounded-lg border border-slate-200 mb-6" data-id="element-868" data-mp="3loa4sjkgwq4v">
        <p className="text-slate-700" data-id="element-869" data-mp="3hnq6vds2liho">
          Please provide information about any corporations, dependents with
          special needs, or other special considerations.
        </p>
      </div>

      {/* Corporate Information */}
      <div className="space-y-4" data-id="element-870" data-mp="2p15gognbzcfp">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-871" data-mp="32z2bp8m4zas9">
          Corporate Information
        </h3>

        <div data-id="element-872" data-mp="2xyxv7il8ag21">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-873" data-mp="2xyfrk0w8kzk3">
            Do you own or have an interest in any corporations?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-874" data-mp="da0f2p9f583u">
            <label className="inline-flex items-center" data-id="element-875" data-mp="d9ibt8oc9tmf">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('corporateInfo.exists')} data-id="element-876" data-mp="1hh5nf3ef9mr6" />
              <span className="ml-2" data-id="element-877" data-mp="1qi3uxvo2kcei">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-878" data-mp="1vfwyegxzmsb3">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('corporateInfo.exists')} data-id="element-879" data-mp="1vfdrdv9vlobu" />
              <span className="ml-2" data-id="element-880" data-mp="12pey1nonf51d">No</span>
            </label>
          </div>

          {hasCorporation === 'true' && <div className="space-y-4 p-4 bg-slate-50 rounded-md" data-id="element-881" data-mp="1chaz97m17b9t">
              <div data-id="element-882" data-mp="1cim0p0s086xr">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-883" data-mp="1cj420btixbcj">
                  Name of Corporation
                </label>
                <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter corporation name" {...register('corporateInfo.name')} data-id="element-884" data-mp="k089hk16bj7n" />
              </div>

              <div data-id="element-885" data-mp="lpc38i4gzij6">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-886" data-mp="lryashrd1y1e">
                  Please provide details about the corporation, the assets it
                  owns, and its shareholders
                </label>
                <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Describe the corporation's assets, shareholders, and any relevant details" {...register('corporateInfo.details')} data-id="element-887" data-mp="3l5ig04ilnc40" />
              </div>

              <div data-id="element-888" data-mp="19fokwkpiotmy">
                <label className="block text-navy-800 font-medium mb-2" data-id="element-889" data-mp="19g7sb7hjjzmq">
                  Have you entered into a shareholders agreement?
                </label>
                <div className="flex items-center space-x-4 mb-4" data-id="element-890" data-mp="2rfff4zmk22ie">
                  <label className="inline-flex items-center" data-id="element-891" data-mp="2wd78ly2ulwop">
                    <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('corporateInfo.shareholdersAgreement')} data-id="element-892" data-mp="2id67qiml2p98" />
                    <span className="ml-2" data-id="element-893" data-mp="3b3esmi8i7nri">Yes</span>
                  </label>
                  <label className="inline-flex items-center" data-id="element-894" data-mp="3f2dvzyel7cgu">
                    <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('corporateInfo.shareholdersAgreement')} data-id="element-895" data-mp="31c0kxn6efhna" />
                    <span className="ml-2" data-id="element-896" data-mp="3tybmp15qrolo">No</span>
                  </label>
                </div>
              </div>
            </div>}
        </div>
      </div>

      {/* Dependents with Special Needs */}
      <div className="space-y-4" data-id="element-897" data-mp="255yxqsidtjd8">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-898" data-mp="254xkchdw8ksc">
          Dependents with Special Needs
        </h3>

        <div data-id="element-899" data-mp="216hs9z2ygm82">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-900" data-mp="1w5ajbwp2tgzt">
            Do you have any dependents with special needs?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-901" data-mp="2sui8deowm88h">
            <label className="inline-flex items-center" data-id="element-902" data-mp="2ou801vdn35qg">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('specialNeeds.exists')} data-id="element-903" data-mp="2ourjjgixu26l" />
              <span className="ml-2" data-id="element-904" data-mp="2f22a0r6y6ydw">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-905" data-mp="3cklshn04z6lk">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('specialNeeds.exists')} data-id="element-906" data-mp="37su33fspv6x0" />
              <span className="ml-2" data-id="element-907" data-mp="3k2teqdecqscj">No</span>
            </label>
          </div>

          {watch('specialNeeds.exists') === 'true' && <div data-id="element-908" data-mp="3p1d64tbpswca">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-909" data-mp="3p0uzd2rfezq4">
                Please provide details
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Describe the special needs and any relevant details" {...register('specialNeeds.details')} data-id="element-910" data-mp="1xq7on4ts69h" />
            </div>}
        </div>
      </div>

      {/* Beneficiaries on ODSP */}
      <div className="space-y-4" data-id="element-911" data-mp="kopqt7pn2luu">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-912" data-mp="kpiycawf9fe1">
          Beneficiaries on ODSP
        </h3>

        <div data-id="element-913" data-mp="2lq5sv0avbgo5">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-914" data-mp="2lpnx04s4b4gr">
            Do you have any beneficiaries who are on ODSP (Ontario Disability
            Support Program)?
          </label>
          <div className="flex items-center space-x-4 mb-4" data-id="element-915" data-mp="2vfpci86enek2">
            <label className="inline-flex items-center" data-id="element-916" data-mp="2vha8m28db5k1">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('odspBeneficiaries.exists')} data-id="element-917" data-mp="2qp0mkxadipn1" />
              <span className="ml-2" data-id="element-918" data-mp="30eaae0y6pm5c">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-919" data-mp="3efd0cosavglj">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('odspBeneficiaries.exists')} data-id="element-920" data-mp="3ee1u8ibdtwr9" />
              <span className="ml-2" data-id="element-921" data-mp="1k2n4w2ma9zc1">No</span>
            </label>
          </div>

          {watch('odspBeneficiaries.exists') === 'true' && <div data-id="element-922" data-mp="3qq3z08tgvrfq">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-923" data-mp="3qpm69m60jvck">
                Please provide details
              </label>
              <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Provide names and relevant details" {...register('odspBeneficiaries.details')} data-id="element-924" data-mp="3vq04ydlq5sxx" />
            </div>}
        </div>
      </div>

      {/* Other Special Considerations */}
      <div className="space-y-4" data-id="element-925" data-mp="2yy69izaqss8m">
        <h3 className="text-lg font-medium text-navy-900 border-b border-slate-200 pb-2" data-id="element-926" data-mp="2yyy6adg2sw0h">
          Other Special Considerations
        </h3>

        <div data-id="element-927" data-mp="331bc11utotx9">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-928" data-mp="x6jpjhp9pxln">
            Are there any other special considerations we should be aware of?
          </label>
          <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={4} placeholder="Please describe any other special considerations" {...register('specialConsiderations')} data-id="element-929" data-mp="117c1wjtfsim5" />
        </div>
      </div>
    </div>;
};
export default SpecialNeeds;